import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import { toggleNPaymentType } from "Constants/Constants";
import { read, store } from "Helpers/LocalStorage";
import PaymentService from "Services/http/endpoints/payment/PaymentService";
import StatusHandler from "Helpers/StatusHandler";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiButton from "Components/MuiButton/MuiButton";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import MaxFourNumber from "Components/Input/components/MaxFourNumber";
import Translator from "Languages/Utility/Translator";
import * as R from "ramda";
import showNotify from "Helpers/Notify";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { Typography, useTheme } from "@material-ui/core";
import PageTitle from "Components/PageTitle/PageTitle";
import { push } from "Helpers/History";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from "react-bootstrap-icons";
import PaymentDetailsItems from "./PaymentDetailsItems";

function UserIncrease() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [loading, setLoading] = useState(false);
  const [dataTime, setDataTime] = useState([]);
  const [dataCalculate, setDataCalculate] = useState([]);
  const [formValid, setFormValid] = useState({ discount: true, countUsers: true });
  const [isShowDetails, setIsShowDetails] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [isSendValidate, setIsSendValidate] = useState(false);
  const [price, setPrice] = useState("?");

  const [controls, setControls] = useSetState({
    countUsers: {
      value: "1",
      validation: {
        isNumeric: true,
        min: 1,
      },
    },
    payType: {
      arrayItems: toggleNPaymentType,
      value: toggleNPaymentType[1],
      validation: {
        required: true,
      },
    },
    discount: {
      value: "",
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const onClickCalculate = async () => {
    if (Object.values(formValid).every((item) => item === true)) {
      setLoading(true);
      const { countUsers, discount } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Count: countUsers.value,
          DiscountCode: discount.value,
        };
        const response = await PaymentService.postCountCalculate(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const saleCalculate = response.data.Value;
          setDataCalculate(saleCalculate);
          setPrice(saleCalculate?.PriceShow);
          setDataTime(saleCalculate);
          setIsSendValidate(false);
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  };
  const onClickDiscount = () => {
    setIsDiscount(true);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { countUsers, payType, discount } = controls;
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Count: countUsers.value,
          TypePayment: +payType.value.value,
          DiscountCode: discount.value,
        };
        const response = await PaymentService.postIncreaseUser(data);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const pay = response.data.Value;
          if (+payType.value.value === 1 && pay.IsError === false) {
            store("orderId", pay.Describ);
            window.open(pay.Link, "_self");
          } else if (+payType.value.value === 1 && pay.IsError === true) {
            showNotify({ text: pay.Describ, customClass: "error" });
          }
          if (+payType.value.value === 2 && pay.IsError === false) {
            showNotify({
              text: pay.Describ,
              customClass: "success",
            });
            push("/dashboard/payment/information-panel");
          } else if (+payType.value.value === 2 && pay.IsError === true) {
            showNotify({
              text: pay.Describ,
              customClass: "error",
            });
          }
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        setIsSendValidate(true);
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        const response = await PaymentService.GetRemainTime(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const remainTime = response.data.Value;
          setDataTime(remainTime);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    setIsSendValidate(true);
    setIsShow(true);
    setPrice("?");
  }, [controls.countUsers, controls.discount]);

  const onClickViewDetails = () => {
    setIsShowDetails(true);
    setIsShow(false);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <PageTitle className="mt-4" title={<Translator id={"form_add_user"} />} />
      <Grid
        container
        spacing={2}
        className={`p-4 ${direction === "rtl" ? "text-right" : "text-left"}`}
      >
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <Typography variant={"body2"} align="left">
            <p>
              {`${t("expiryCreditDate")} : `}
              <strong className="mx-2">{dataTime?.JalaliDate}</strong>
            </p>
          </Typography>
        </Grid>
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <Typography variant={"body2"}>
            <p>
              {`${t("RemainingTime")} : `}
              <strong className="mx-1">
                {`${dataTime.RemaingTime?.Years} ${t("info_Years")} ,
                    ${dataTime.RemaingTime?.Months} ${t("month")} , 
                    ${dataTime.RemaingTime?.Days} ${t("day")} , 
                    ${dataTime.RemaingTime?.Hours} ${t("hour")} , 
                    ${dataTime.RemaingTime?.Minutes} ${t("minute")}`}
              </strong>
            </p>
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <MuiPaper>
            <Grid container spacing={1} className="p-3">
              <Grid item xs={12}>
                <Input
                  setValue={setValue.bind(this)}
                  options={controls.countUsers.selectItems}
                  value={controls.countUsers.value}
                  validation={controls.countUsers.validation}
                  label={<Translator id={"numberUsers"} />}
                  icon={<Icons.Person />}
                  type="text"
                  name="countUsers"
                  inputComponent={MaxFourNumber}
                />
              </Grid>
              {!isDiscount ? (
                <Grid item xs={12} className="pt-0 pb-2">
                  <MuiButton
                    className="link p-1 pt-0"
                    title={t("haveDiscountCode")}
                    onClick={onClickDiscount}
                  />
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Input
                    setValue={setValue.bind(this)}
                    value={controls.discount.value}
                    name="discount"
                    type="text"
                    placeholder={t("enterDiscountCode")}
                  />
                </Grid>
              )}
              <Grid item sm={7} xs={12}>
                <MuiButton
                  className="w-100"
                  color="primary"
                  title={t("priceCalculation")}
                  onClick={onClickCalculate}
                />
              </Grid>
              <Grid item sm={5} xs={12}>
                <MuiButton
                  className="w-100"
                  color="secondary"
                  title={t("viewDetails")}
                  onClick={onClickViewDetails}
                  disabled={isSendValidate}
                />
              </Grid>
            </Grid>
          </MuiPaper>
        </Grid>
        <Grid item lg={4} md={6} sm={12} xs={12}>
          <MuiPaper>
            <Grid container spacing={1} className="p-3">
              <Grid item xs={12} className="payment-price-show">
                <div>
                  <span>{`${t("totalPayment")}:`}</span>
                  <p>{price.toLocaleString()}</p>
                  <Translator id="moneyUnit" />
                </div>
                <span className="calc-info-text">
                  {price === "?"
                    ? t("paymentCalcInfoPage")
                    : t("addUserCalculatedPrice")}
                </span>
              </Grid>
              <span className="calc-warn-text">
                {t("priceWithTax")}
              </span>
              <Grid item xs={12} className="mt-2">
                <MuiRadioGroup
                  label={<Translator id={"paymentType"} />}
                  name="payType"
                  value={controls.payType.value}
                  items={controls.payType.arrayItems}
                  translate={true}
                  onChange={onChangeRadio}
                  className="horizontalRadio"
                />
              </Grid>
              <Grid item xs={12}>
                <MuiButton
                  className="w-100"
                  color="primary"
                  title={<Translator id="payment" />}
                  disabled={isSendValidate}
                  onClick={onFinish}
                />
              </Grid>
            </Grid>
          </MuiPaper>
        </Grid>
      </Grid>
      {!isShow && isShowDetails && (
        <PaymentDetailsItems title={"increaseUserDetails"} data={dataCalculate} />
      )}
    </>
  );
}

export default UserIncrease;
